import React, { ChangeEvent } from "react";
import { TablePagination } from "@mui/material";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";
import { Product } from "src/shared/services/interfacev2";
import CommonTable from "src/business-types/grocery/components/CommonTable";
import { notifyWarning } from "src/assets/toastService";
import { ProductRow, Table } from "../../settingInterface";

interface Props {
    tableData: ProductRow[];
    headCells: Table<ProductRow>[];
    deleted: boolean;
    usedPopup: boolean;
    updateProduct: boolean;
    page: number;
    rowsPerPage: number;
    totalRecords: number;
    onPageChange: (_: unknown, newPage: number) => void;
    onRowsChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onDelete: (ids: (string | number)[]) => void;
    onEdit: (id: string | number) => void;
    onSort: (data: { field: string; orderby: string }) => void;
    product: Product[];
}

export default function ProductsTable({
    tableData, headCells, deleted, usedPopup,
    updateProduct, page, rowsPerPage, totalRecords,
    onPageChange, onRowsChange, onDelete, onEdit, onSort, product,
}: Props) {
    return (
        <div className="mx-1 -mt-3 flex justify-center">
            <div className="w-full">
                <CommonTable<ProductRow>
                    data={tableData}
                    headCells={headCells}
                    title=""
                    onDeleteSelected={onDelete}
                    onEditSelected={(id) => {
                        if (updateProduct) {
                            onEdit(id);
                        } else {
                            notifyWarning(
                                "Product update access is restricted for your account. Please contact your business owner or admin."
                            );
                        }
                    }}
                    selectable={false}
                    pagenation={false}
                    pageSize={rowsPerPage}
                    Action={!deleted && !usedPopup}
                    shortByTable={false}
                    OrderType={onSort}
                />
                <div className="w-[95%] mx-auto border-t mt-2">
                    <TablePagination
                        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
                        component="div"
                        count={totalRecords}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={onPageChange}
                        onRowsPerPageChange={onRowsChange}
                    />
                </div>
            </div>
        </div>
    );
}